import { normalizeRouteName } from './context.js';
import { countMetric } from './metrics.js';

const NAVIGATION_TYPE_MAP = {
  0: 'navigate',
  1: 'reload',
  2: 'back_forward'
};

/**
 * 获取浏览器全局对象，SSR 或脚本探测环境下返回空对象。
 * @returns {Object} 浏览器全局对象或空对象。
 */
function getGlobalObject() {
  return typeof window !== 'undefined' ? window : {};
}

/**
 * 获取当前页面导航类型。
 * @returns {string} 页面导航类型。
 */
function resolveNavigationType() {
  try {
    const performanceObject = getGlobalObject().performance;
    // PerformanceNavigationTiming 可用时优先读取标准导航类型。
    if (
      performanceObject &&
      typeof performanceObject.getEntriesByType === 'function'
    ) {
      const entries = performanceObject.getEntriesByType('navigation');
      const navigationEntry = entries && entries[0];
      // 标准导航类型存在时直接返回。
      if (navigationEntry && navigationEntry.type) {
        return String(navigationEntry.type);
      }
    }
    const legacyNavigation = performanceObject && performanceObject.navigation;
    // 老版本 performance.navigation 可用时映射到标准导航类型。
    if (legacyNavigation && legacyNavigation.type in NAVIGATION_TYPE_MAP) {
      return NAVIGATION_TYPE_MAP[legacyNavigation.type];
    }
  } catch (error) {}
  return 'unknown';
}

/**
 * 在 WebView reload 时记录疑似闪退次数。
 * @param {Object} options - 上报选项。
 * @param {string} options.runtimeScene - WebView 运行场景。
 * @param {Object|string} options.route - Vue Router 路由对象或路由名。
 * @returns {void}
 */
export function recordWebviewReloadIfNeeded(options = {}) {
  try {
    const runtimeScene = options.runtimeScene;
    // 未明确传入小程序运行场景时不统计，避免普通 H5 污染 WebView 口径。
    if (
      runtimeScene !== 'douyin_miniapp' &&
      runtimeScene !== 'wechat_miniapp'
    ) {
      return;
    }
    const navigationType = resolveNavigationType();
    // 只统计 reload，正常加载不进入疑似闪退次数。
    if (navigationType !== 'reload') {
      return;
    }
    countMetric('h5.page.webview_reload', {
      runtime_scene: runtimeScene,
      route_name: normalizeRouteName(options.route),
      navigation_type: navigationType
    });
  } catch (error) {}
}

/**
 * 启动页面稳定性监控。
 * @param {Object} router - Vue Router 实例。
 * @returns {Function} 停止监控函数。
 */
export function startPageMonitor(router) {
  // 当前任务只建立公共出口，实际路由探针由页面稳定性任务接入。
  if (!router) {
    return function stopEmptyPageMonitor() {};
  }
  return function stopPageMonitor() {};
}
